<template>
  <div :class="['leaderboard-info', isShare ? 'share' : '']">
    <div class="player-profile" v-if="showScoreView">
      <svg v-if="userInfo.rank === 1" fill="none">
        <use :xlink:href="mobileView ? '#golf-ball-stand-mb' : '#gold-crown'"></use>
        <text v-if="!mobileView" x="50%" y="82.5%" fill="#000000" text-anchor="middle" alignment-baseline="middle" stroke="#000000" stroke-width="1">
          {{ userInfo.rank }}
        </text>
      </svg>
      <svg v-else-if="userInfo.rank === 2" fill="none">
        <use :xlink:href="mobileView ? '#golf-ball-stand-mb' : '#silver-crown'"></use>
        <text v-if="!mobileView" x="50%" y="82.5%" fill="#000000" text-anchor="middle" alignment-baseline="middle" stroke="#000000" stroke-width="1">
          {{ userInfo.rank }}
        </text>
      </svg>
      <svg v-else-if="userInfo.rank === 3" fill="none">
        <use :xlink:href="mobileView ? '#golf-ball-stand-mb' : '#bronze-crown'"></use>
        <text v-if="!mobileView" x="50%" y="82.5%" fill="#000000" text-anchor="middle" alignment-baseline="middle" stroke="#000000" stroke-width="1">
          {{ userInfo.rank }}
        </text>
      </svg>
      <svg v-else fill="none">
        <use :xlink:href="mobileView ? '#golf-ball-stand-mb' : '#golf-ball'"></use>
        <text v-if="!mobileView" x="50%" y="82.5%" fill="#000000" text-anchor="middle" alignment-baseline="middle" stroke="#000000" stroke-width="1">
          {{ userInfo.rank }}
        </text>
      </svg>
      <span class="name">{{ userInfo.name }}</span>
      <span class="rank" v-if="mobileView">Sæti {{ String(userInfo.rank).padStart(2, '0') }}</span>
    </div>
    <div class="club-profile" v-else>
      <img :src="clubInfo.image_url" alt="img" height="138" width="138" />
      <span class="name">{{ clubInfo.name }}</span>
      <span class="rank">Sæti {{ String(clubInfo.rank).padStart(2, '0') }}</span>
    </div>
    <div class="club-target" v-if="isClubPresentation && clubInfo.rank !== 1">
      <div class="current-club">
        <img :src="clubInfo.image_url" alt="" height="40" width="40" />
        <span>{{ String(clubInfo.rank).padStart(2, '0') }}</span>
      </div>
      <div class="club-compare" v-if="clubData">
        <span class="divider" :style="{ '--percent': `${getCssPercentage()}%` }"></span>
        <span class="text">
          Vantar {{ computeBalanceClubPoints() }} stig í viðbót til að ná {{ clubInfo.rank - 1 }}. sæti
        </span>
      </div>
      <div class="target-club" v-if="clubData">
        <img :src="clubData.target_club.image_url" alt="" height="40" width="40" />
        <span>{{ String(clubData.target_club.rank).padStart(2, '0') }}</span>
      </div>
    </div>
    <div class="related-info" :class="[showClubMemView || !showScoreView ? 'two-column': 'three-column']">
      <div class="arrow top-left"></div>
      <div class="arrow top-right"></div>
      <div class="info-group" v-for="item in selectedItem" :key="item.title">
        <span class="title">{{ item.title }}</span>
        <span class="content">{{ item.value }}</span>
      </div>
      <div class="arrow bottom-left"></div>
      <div class="arrow bottom-right"></div>
    </div>
    <div class="btn-wrapper" v-if="!isClubPresentation && !hideBtn">
      <button class="btn-spila" @click="$router.push('/spurningar/')">{{ pageContent.cta_links[0].text }}</button>
      <button class="new-btn-share" v-if="showScoreView && userInfo.total_turns_played" @click="$emit('share')">{{ pageContent.cta_links[1].text }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'leaderboardInfo',
  props: [
    'isShare',
    'userInfo',
    'clubInfo',
    'clubData',
    'isClubPresentation',
    'showScoreView',
    'showClubMemView',
    'mobileView',
    'pageContent',
    'selectedItem',
    'hideBtn',
  ],
  data () {
    return {}
  },
  methods: {
    getCssPercentage() {
      const newVal = this.clubData.target_club.total_points/(this.clubData.target_club.total_members || 1)
      const oldVal = this.clubInfo.total_points/(this.clubInfo.total_members || 1)
      return newVal - oldVal ? Math.round(((newVal-oldVal)/newVal)*100) : 0
    },
    computeBalanceClubPoints() {
      const currentClubPoints = ((this.clubInfo.total_points || 0)/(this.clubInfo.total_members || 1)).toFixed(2)
      const targetClubPoints = ((this.clubData.target_club.total_points || 0)/(this.clubData.target_club.total_members || 1)).toFixed(2)
      return (targetClubPoints - currentClubPoints).toFixed(2)
    },
  }
}
</script>

<style lang="scss" scoped>
.leaderboard-info {
  max-width: 408px;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 121px;
  .player-profile, .club-profile {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 24px 0;
    margin-bottom: 20px;
    .name {
      font-weight: 500;
      font-size: 22px;
      line-height: 26.4px;
      text-align: center;
    }
    svg, img {
      height: 138px;
      width: 138px;
    }
  }
  .club-profile {
    gap: 0;
    img {
      margin-bottom: 18px;
    }
    .name {
      margin-bottom: 7px;
    }
    .rank {
      font-weight: 500;
      font-size: 16px;
      line-height: 19.2px;
      color: #011627;
    }
  }
  .club-target {
    display: flex;
    align-items: center;
    gap: 26px;
    margin: 7px 0 40px;
    img {
      height: 40px;
      width: 40px;
      border-radius: 50%;
    }
    .current-club, .target-club {
      display: flex;
      align-items: center;
      flex-direction: column;
      gap: 2px;
      flex: 1 0 auto;
      span {
        font-weight: 500;
        font-size: 14px;
        line-height: 16.8px;
        color: #000000;
      }
    }
    .club-compare {
      display: flex;
      align-items: center;
      gap: 9px;
      flex-direction: column;
      .divider {
        --percent: 0%;
        --border-width: 3px;
        border: var(--border-width) solid #CCD0D4;
        border-radius: 6px;
        width: 100%;
        position: relative;
        &::before {
          content: '';
          position: absolute;
          left: calc(0px - var(--border-width));
          top: calc(0px - var(--border-width));
          width: calc(100% - var(--percent) + var(--border-width) * 2);
          border: var(--border-width) solid #2EC4B6;
          border-radius: 6px;
        }
      }
      .text {
        font-weight: 500;
        font-size: 14px;
        line-height: 16.8px;
        color: #808A93;
        text-align: center;
      }
    }
  }
  .related-info {
    display: flex;
    align-items: center;
    padding: 33.5px 16px;
    flex-flow: row wrap;
    gap: 24px 0;
    margin-bottom: 32px;
    position: relative;
    .arrow {
      position: absolute;
      height: 23px;
      width: 23px;
      border: 2px solid #FCBD00;
      &.top-left {
        top: 0;
        left: 0;
        border-right: none;
        border-bottom: none;
      }
      &.top-right {
        top: 0;
        right: 0;
        border-left: none;
        border-bottom: none;
      }
      &.bottom-left {
        bottom: 0;
        left: 0;
        border-right: none;
        border-top: none;
      }
      &.bottom-right {
        bottom: 0;
        right: 0;
        border-left: none;
        border-top: none;
      }
    }
    &.three-column {
      .info-group {
        flex: 0 0 calc(100% / 3);
      }
    }
    &.two-column {
      .info-group {
        flex: 0 0 calc(100% / 2);
      }
    }
    .info-group {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .title {
        font-weight: 500;
        font-size: 12px;
        line-height: 14.4px;
        color: #808A93;
        text-transform: uppercase;
        white-space: nowrap;
      }
      .content {
        font-weight: 600;
        font-size: 30px;
        line-height: 36px;
        color: #000000;
      }
    }
  }
  .btn-wrapper {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 9px;
    width: 100%;
    font-weight: 600;
    font-size: 18px;
    line-height: 21.6px;
    .btn-spila, .new-btn-share {
      width: 100%;
      outline: none;
      height: 50px;
      border-radius: 10px;
    }
    .btn-spila {
      border: none;
      background-color: #FCBD00;
    }
    .new-btn-share {
      border: 1.5px solid #FCBD00;
      border-radius: 10px;
      background-color: #ffffff;
      &:disabled {
        opacity: 0.3;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .leaderboard-info:not(.cloned) {
    margin-top: 0px;
    &:not(.share) {
      .player-profile, .club-profile {
        svg, img {
          height: 60px;
          width: 60px;
        }
      }
    }
    .player-profile, .club-profile {
      gap: 4px;
      margin-bottom: 20px;
      .name {
        font-size: 18px;
        line-height: 21.6px;
      }
      .rank {
        font-size: 14px;
        font-weight: 400;
        line-height: 16.8px;
        color: #808A93;
      }
      &:is(.club-profile) {
        img, .name {
          margin-bottom: 0;
        }
      }
    }
    .related-info {
      padding: 12px;
      gap: 10px 0;
      margin-bottom: 0;
      .info-group {
        .title {
          font-size: 11px;
          line-height: 13.2px;
        }
        .content {
          font-size: 20px;
          line-height: 24px;
        }
      }
      .arrow {
        border-width: 1px;
      }
    }
    .btn-wrapper {
      position: fixed;
      bottom: 0;
      z-index: 2;
      flex-direction: row;
      gap: 8px;
      padding: 8px 18px 16px;
      font-weight: 500;
      font-size: 16px;
      line-height: 19.2px;
      background: #F8F8F8;
      .btn-spila {
        order: 2;
      }
      .new-btn-share {
        order: 1;
      }
    }
  }
}
</style>